import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { GET_INVOICES, GetInvoicesFailureAction, GetInvoicesSuccessAction, InvoicesAction } from './invoices.action';
import { InvoicesService } from './invoices.service';
import { Invoice } from './invoice';

@Injectable()
export class InvoicesEffects {
  @Effect()
  getInvoices$: Observable<InvoicesAction> = this.actions$.pipe(
    ofType(GET_INVOICES),
    switchMap(() =>
      this.invoicesService
        .getInvoices()
        .pipe(
          map((response: Invoice[]) => new GetInvoicesSuccessAction(response)),
          catchError(error => of(new GetInvoicesFailureAction(error)))
        )
    )
  );

  constructor(private actions$: Actions, private invoicesService: InvoicesService) {}
}
